module.exports = __webpack_public_path__ + "img/wma.b072de5d.svg";